<div class="wrapper" (mouseout)="reset()">
   <span *ngIf="is_loading" class="material-symbols-outlined spinner spin-animation">
       cached
    </span>
    <span *ngIf="_values.length == 0">
    <div class="text-placeholder w20"></div>&nbsp;
    <div class="text-placeholder w70"></div>&nbsp;
    <div class="text-placeholder w40"></div>
  </span>
    <element-clipboard *ngIf="_values.length == 1" [value]="_values[0]"></element-clipboard>
    <div *ngIf="(current_role == Role.Alpha || current_role == Role.Clerk ||  current_role == Role.Manager)">
    <span class="material-symbols-outlined icon-delete" (click)="toggle_delete(_values[0])"
          *ngIf="batch != null && !delete_toggled && _values.length == 1 && type">delete</span>
        <span class="material-symbols-outlined icon-delete" (click)="delete()"
              *ngIf="delete_toggled && _values.length == 1">done</span>
    </div>
    <i *ngIf="_values.length > 1" class="icon-cheveron-down"><span>{{label}}s</span></i>
    <ul *ngIf="_values.length > 1">
        <li *ngFor="let value of _values" [ngClass]="{'delete-toggled':delete_toggled && value == delete_toggled_for}">
            <element-clipboard [value]="value" color="black"></element-clipboard>
            <div *ngIf="(current_role == Role.Alpha || current_role == Role.Clerk ||  current_role == Role.Manager)">
        <span class="material-symbols-outlined icon-delete" (click)="toggle_delete(value)"
              *ngIf="batch != null && value != delete_toggled_for">delete</span>
                <span class="material-symbols-outlined icon-delete" (click)="delete()"
                      *ngIf="delete_toggled && value == delete_toggled_for">done</span>
            </div>
        </li>
    </ul>
</div>
